import * as settings from '../settings/settings';
export function start() {
    // @ts-ignore
    ;
    (function (e, x, pe, r, i, me, nt) {
        ;
        (e[i] =
            e[i] ||
                function () {
                    ;
                    (e[i].a = e[i].a || []).push(arguments);
                }),
            (me = x.createElement(pe)),
            (me.async = 1),
            (me.src = r),
            (nt = x.getElementsByTagName(pe)[0]),
            nt.parentNode.insertBefore(me, nt);
    })(window, document, 'script', 'https://abt.s3.yandex.net/expjs/latest/exp.js', 'ymab');
    var ID = "metrika.".concat(COUNTER_ID);
    // @ts-ignore
    ymab(ID, 'init' /*, {clientFeatures}, {callback}*/);
    // @ts-ignore
    ymab(ID, 'getFlags', function (flags) {
        // settings = {"useStartScreen":false}
        if (DEVELOPMENT) {
            console.log({ flags: flags });
        }
        if (flags && flags['settings']) {
            try {
                var data = JSON.parse(flags['settings'][0]);
                settings.override(data);
            }
            catch (err) {
                console.error(err);
            }
        }
    });
}
